import React from 'react';
import axios from 'axios';
import { Button, Form, Header, Segment } from 'semantic-ui-react';
import { ToastContainer } from 'react-toastify';

axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
// axios.defaults.crossDomain = true;

class NewSP5 extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            details: this.props.details,
            gradingScale: this.props.gradingScale,
            classificationOfQualification: this.props.classificationOfQualification,
            detailsEng: this.props.detailsEng,
            gradingScaleEng: this.props.gradingScaleEng,
            classificationOfQualificationEng: this.props.classificationOfQualificationEng
        };

        this.handleInputChange = this.handleInputChange.bind(this);
        this.previousStep = this.previousStep.bind(this);
        this.createSP = this.createSP.bind(this);
    }


    handleInputChange(event, { name, value }) {
        this.setState({
            [name]: value
        });
    }

    previousStep() {
        const step = 4;
        this.props.previousStep(step);
    }

    createSP() {
        this.props.createSP(
            this.state.details,
            this.state.gradingScale,
            this.state.classificationOfQualification,
            this.state.detailsEng,
            this.state.gradingScaleEng,
            this.state.classificationOfQualificationEng,
        );
    }


    render() {
        return (
            <div>
                <Header as="h1">Kreiranje implementacije smjera (studijskog programa)</Header>

                <Segment.Group raised>
                    <Segment raised>
                        <Header as="h3">
                            Ostali podaci o smjeru (studijskom programu)
                        </Header>
                    </Segment>
                    <Segment>
                        <Form>
                            <Form.Group widths="equal">
                                <Form.Field>
                                    <label>Detalji</label>
                                    <Form.TextArea
                                        placeholder="Bosanski / hrvatski / srpski"
                                        rows={5}
                                        value={this.state.details}
                                        onChange={(e) => this.setState({ details: e.target.value })}
                                    />
                                </Form.Field>
                                <Form.Field>
                                    <label>Detalji</label>
                                    <Form.TextArea
                                        placeholder="Engleski jezik"
                                        rows={5}
                                        value={this.state.detailsEng}
                                        onChange={(e) => this.setState({ detailsEng: e.target.value })}
                                    />
                                </Form.Field>
                            </Form.Group>
                            <Form.Group widths="equal">
                                <Form.Field>
                                    <label>Bodovni sistem i ocjenjivanje</label>
                                    <Form.TextArea
                                        placeholder="Bosanski / hrvatski / srpski"
                                        rows={5}
                                        value={this.state.gradingScale}
                                        onChange={(e) => this.setState({ gradingScale: e.target.value })}
                                    />
                                </Form.Field>
                                <Form.Field>
                                    <label>Bodovni sistem i ocjenjivanje</label>
                                    <Form.TextArea
                                        placeholder="Engleski jezik"
                                        rows={5}
                                        value={this.state.gradingScaleEng}
                                        onChange={(e) => this.setState({ gradingScaleEng: e.target.value })}
                                    />
                                </Form.Field>
                            </Form.Group>
                            <Form.Group widths="equal">
                                <Form.Field>
                                    <label>Stepeni i kvalifikacije</label>
                                    <Form.TextArea
                                        placeholder="Bosanski / hrvatski / srpski."
                                        rows={5}
                                        value={this.state.classificationOfQualification}
                                        onChange={(e) => this.setState({ classificationOfQualification: e.target.value })}
                                    />
                                </Form.Field>
                                <Form.Field>
                                    <label>Stepeni i kvalifikacije</label>
                                    <Form.TextArea
                                        placeholder="Engleski jezik"
                                        rows={5}
                                        value={this.state.classificationOfQualificationEng}
                                        onChange={(e) => this.setState({ classificationOfQualificationEng: e.target.value })}
                                    />
                                </Form.Field>
                            </Form.Group>
                        </Form>
                    </Segment>
                    <Segment clearing>
                        <Button
                            color="blue"
                            basic="true"
                            onClick={this.previousStep}
                        >Nazad</Button>
                        <Button
                            color="blue"
                            floated="right"
                            onClick={this.createSP}
                        >Kreiraj implementaciju smjera (studijskog programa)</Button>

                    </Segment>
                    <ToastContainer hideProgressBar />
                </Segment.Group>
            </div>
        );
    }
}

export default NewSP5;



// WEBPACK FOOTER //
// ./src/views/Admin/CreateStudyProgramImplementation/NewSP5.js